import React, { useEffect, useState } from 'react';
import cl from './Products.module.css';
import Product from './Product/Product';
import { animateScroll as scroll } from 'react-scroll';

const Products = (props) => {
  useEffect(() => {
    scroll.scrollToTop();
  }, []);

  const [howMuch, setHowMuch] = useState(6);
  const [isShow, setIsShow] = React.useState(true);
  let featuredProducts = (p) => {
    if (props.productsData.indexOf(p) < howMuch) {
      return (
        <Product
          key={p.path}
          onAdd={props.onAdd}
          productId={p.productId}
          name={p.name}
          images={p.images}
          oldPrice={p.oldPrice}
          currency={p.currency}
          discount={p.discount}
          path={p.path}
          cartItems={props.cartItems}
        />
      );
    }
  };

  let onShowMore = () => {
    if (howMuch < props.productsData.length - 6) {
      setHowMuch(howMuch + 6);
    } else {
      setHowMuch(howMuch + 6);
      setIsShow(!isShow);
    }
  };

  let productElements = props.productsData.map((p) => featuredProducts(p));

  return (
    <section className={cl.main}>
      <div>
        <h1 className={cl.title}>Tutti i prodotti</h1>
      </div>
      <div className={cl.products}>{productElements}</div>
      <div className={cl.products_more}>
        {isShow && (
          <p className={cl.button} onClick={onShowMore}>
            Show more
          </p>
        )}
      </div>
    </section>
  );
};

export default Products;
